import React, { useEffect, useRef, useState } from "react";
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PaymentChallan from "../../../citizen/PaymentChallan";
import DescriptionIcon from "@mui/icons-material/Description";
import ReactToPrint from "react-to-print";
import PrintIcon from "@mui/icons-material/Print";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { Login } from "@mui/icons-material";

const PaymentChallanPopup = ({ formData, item, taxHead, totalAmount, logoData }) => {
  const [open, setOpen] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const [, setIsPreviewLoading] = useState(false);
  const conponentPDF = useRef();
  const isDA = formData?.department === "DA";
  const isLandUse = formData?.applicationType === "FORM_LANDUSE";
  const boundaryKey = isLandUse ? formData?.location1 : formData?.locationDistrict;
  const currentLogoId = isDA ? logoData?.boundary?.find((item) => item?.name === boundaryKey)?.fileStoreId : logoData?.fileStoreId;
  const fetchLogoUrl = async () => {
    console.log("insideFetchURLLogo", currentLogoId);
    if (!currentLogoId) return;

    const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
    console.log("resultURLLogo", result);

    setLogoUrl(result);
  };
  useEffect(() => {
    fetchLogoUrl();
  }, [currentLogoId, logoData, formData]);
  return (
    <React.Fragment>
      <Button variant="contained" onClick={() => setOpen(true)}>
        <DescriptionIcon fontSize="small" />
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            //   marginTop: '10%',
            position: "fixed",
            top: "10%",
            left: "55%",
            transform: "translateX(-50%)",
            backgroundColor: "#f3f4f6",
            border: "1px solid #ccc",
            padding: "20px",
            zIndex: 1000,
            maxHeight: "80vh",
            overflowY: "auto",
            width: "75%",
          },
        }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Payment Challan
          <div style={{ display: "flex", gap: "10px" }}>
            <ReactToPrint trigger={() => <PrintIcon />} content={() => conponentPDF.current} />

            <IconButton onClick={() => setOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent dividers>
          <div ref={conponentPDF}>
            <PaymentChallan formData={formData} item={item} taxHead={taxHead} totalAmount={totalAmount} logoUrl={logoUrl} />
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default PaymentChallanPopup;
